import React, { ForwardedRef } from "react";
import clsx from "clsx";

import TextField from "../TextField";
import { ButtonTextFieldProps } from "./ButtonTextField.types";
import {
  useStyles,
  useInputLabelStyles,
  useInputStyles,
  useFormHelperTextStyles,
} from "./ButtonTextField.styles";

const ButtonTextField = React.forwardRef(function ButtonTextField(
  props: ButtonTextFieldProps,
  ref: ForwardedRef<HTMLDivElement>
) {
  const {
    InputLabelProps: InputLabelPropsProp,
    InputProps: InputPropsProp,
    FormHelperTextProps: FormHelperTextPropsProp,
    size,
    error,
    disabled,
    buttonColor,
    buttonIcon,
    buttonIconColor,
    onButtonClick,
    ...other
  } = props;

  const inputLabelClasses = useInputLabelStyles(InputLabelPropsProp);

  const inputClasses = useInputStyles(InputPropsProp);

  const formHelperTextClasses = useFormHelperTextStyles(
    FormHelperTextPropsProp
  );

  const classes = useStyles();

  const startIconClassName = clsx(classes.button, {
    [classes.buttonError]: error,
    [classes.buttonSmall]: size === "small",
  });

  const startIcon = (
    <button
      className={startIconClassName}
      onClick={onButtonClick}
      type="button"
      style={{ backgroundColor: buttonColor, fill: buttonIconColor }}
    >
      {buttonIcon}
    </button>
  );

  const InputLabelProps = React.useMemo(() => {
    return {
      ...InputLabelPropsProp,
      classes: inputLabelClasses,
    };
  }, [InputLabelPropsProp, inputLabelClasses]);

  const InputProps = React.useMemo(() => {
    return {
      ...InputPropsProp,
      classes: inputClasses,
    };
  }, [InputPropsProp, inputClasses]);

  const FormHelperTextProps = React.useMemo(() => {
    return {
      ...FormHelperTextPropsProp,
      classes: formHelperTextClasses,
    };
  }, [FormHelperTextPropsProp, formHelperTextClasses]);

  return (
    <TextField
      {...other}
      ref={ref}
      disabled={disabled}
      error={error}
      InputLabelProps={InputLabelProps}
      InputProps={InputProps}
      FormHelperTextProps={FormHelperTextProps}
      size={size}
      startIcon={startIcon}
    />
  );
});

export default ButtonTextField;
